
export default {
  props: {
    dataset: { type: Object, required: true },
    showTopics: { type: Boolean, default: false },
    showOwner: { type: Boolean, default: false },
    showTable: { type: Boolean, default: false },
    noLink: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    listItemProps: { type: Object, default: () => ({}) },
    checkbox: { type: Boolean, default: null }
  },
  data: () => ({
    hover: false
  })
}
